class StatePopup extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.js-search-input');
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    this.template = this.getAttribute('data-template');
    this.confirmButton = this.querySelector('#confirm-selection');
    this.closeButton = this.querySelector('#close-state-popup');
    this.backButton = this.querySelector('#back-btn');
    this.warningButton = this.querySelector('#show-warning-btn');
    this.errorMessage = this.querySelector('#error-message');
    this.deliveryLocation = this.querySelector('#delivery-location');
    this.pickupLocation = this.querySelector('#pickup-location');
    this.deliveryMethod = this.querySelector('#delivery__options');
    this.valid_zip = false;
    this.alreadyClicked = false;
    
    // Attach event listeners
    this.addListeners();
    this.applyApprovedCopy();
    this.fetchStateData();
    this.applyNoLocationCommerceState();

    let preferred = null;
    try {
      const storedPreferred = localStorage.getItem('preferredLocation');
      const parsedPreferred = storedPreferred ? JSON.parse(storedPreferred) : null;
      if (parsedPreferred && typeof parsedPreferred === 'object' && parsedPreferred.id) {
        preferred = parsedPreferred;
      }
    } catch (error) {
      preferred = null;
    }

    // Preserve saved-location initialization, but never auto-open the selector
    // when the shopper has not chosen a fulfillment location.
    if (preferred) {
      this.checkLocalStorage();
      this.updateHeaderDisplay(preferred.location, preferred.method);
      this.updateHeaderDisplay(preferred.location, preferred.method, true);
    } else {
      this.updateHeaderDisplay('Shopping location', 'Choose pickup or delivery');
      this.updateHeaderDisplay('Shopping location', 'Choose pickup or delivery', true);
    }
  }

  addListeners(){
    this.confirmButton.addEventListener('click', this.handleConfirm.bind(this));
    this.closeButton.addEventListener('click', this.handleClose.bind(this));
    this.backButton.addEventListener('click', this.handleBack.bind(this));
    this.warningButton.addEventListener('click', this.handleWarning.bind(this));
    this.input.addEventListener('input', debounce(this.handleInput.bind(this), 450));
    this.deliveyOptions = this.querySelectorAll('.delivery__option');
    this.deliveyOptions.forEach((option) => {
      option.addEventListener('click', this.handleDeliveryOptionClick.bind(this, option));
    });
  }


  applyApprovedCopy() {
    const title = this.querySelector('#popup-title');
    if (title) title.textContent = 'Choose Pickup or Local Delivery';

    const description = this.querySelector('#popup-description');
    if (description) {
      description.innerHTML = '<p>Select how you\'d like to shop with us. We\'ll use your selection to show availability at the right Paws on Chicon location.</p>';
    }

    const zipContainer = this.querySelector('.zip__container');
    if (zipContainer) {
      let deliverySupport = zipContainer.querySelector('.location-support-text');
      if (!deliverySupport) {
        deliverySupport = document.createElement('p');
        deliverySupport.className = 'location-support-text';
        zipContainer.insertBefore(deliverySupport, zipContainer.firstChild);
      }
      deliverySupport.textContent = 'Enter your ZIP code to see if local delivery is available in your area.';

      const zipLabel = zipContainer.querySelector('label[for="zipcode"]');
      if (zipLabel) zipLabel.textContent = 'Delivery ZIP Code';

      const zipInput = zipContainer.querySelector('#zipcode');
      if (zipInput) zipInput.placeholder = 'Enter ZIP Code';
    }

    const pickupResults = this.querySelector('.pickup-results');
    if (pickupResults) {
      let pickupSupport = pickupResults.querySelector('.location-support-text');
      if (!pickupSupport) {
        pickupSupport = document.createElement('p');
        pickupSupport.className = 'location-support-text';
        pickupResults.insertBefore(pickupSupport, pickupResults.firstChild);
      }
      pickupSupport.textContent = 'Choose the Paws on Chicon location where you\'d like to pick up your order.';

      const pickupLabel = pickupResults.querySelector('label[for="pickup-location-button"]');
      if (pickupLabel) pickupLabel.textContent = 'Pickup Location';
    }

    const deliveryLabel = this.querySelector('label[for="delivery-location-button"]');
    if (deliveryLabel) deliveryLabel.textContent = 'Delivery Location';

    if (this.warningButton) {
      this.warningButton.textContent = 'Use This Location';
    }

    const warningHeading = this.querySelector('.confirm__info .warning-text');
    if (warningHeading) {
      warningHeading.textContent = 'Changing Your Shopping Location';

      let warningBody = this.querySelector('.confirm__info .warning-body');
      if (!warningBody) {
        warningBody = document.createElement('p');
        warningBody.className = 'warning-body text-center';
        warningHeading.insertAdjacentElement('afterend', warningBody);
      }
      warningBody.textContent = 'Product availability varies by Paws on Chicon location. Your cart is currently tied to your selected store so we can make sure the items you choose are available there. Changing your pickup or delivery location will clear the items currently in your cart. You can then shop using availability at your new location.';
    }

    if (this.backButton) {
      this.backButton.textContent = 'Keep Current Location';
    }

    if (this.confirmButton) {
      this.confirmButton.textContent = 'Change Location & Clear Cart';
    }
  }

  applyNoLocationCommerceState(attempt = 0) {
    let preferred = null;

    try {
      const storedPreferred = localStorage.getItem('preferredLocation');
      const parsedPreferred = storedPreferred ? JSON.parse(storedPreferred) : null;

      if (parsedPreferred && typeof parsedPreferred === 'object' && parsedPreferred.id) {
        preferred = parsedPreferred;
      }
    } catch (error) {
      preferred = null;
    }

    if (preferred) return;

    if (!window.stock && attempt < 20) {
      setTimeout(() => this.applyNoLocationCommerceState(attempt + 1), 100);
      return;
    }

    const productInfo = document.querySelector('.product-info');
    if (!productInfo) return;

    const stockLabel = productInfo.querySelector('.stock__label');
    const stockOutImg = productInfo.querySelector('.stock__label .out-stock');
    const stockImg = productInfo.querySelector('.stock__label .in-stock');

    if (stockLabel && stockLabel.lastElementChild) {
      stockLabel.lastElementChild.textContent = 'Choose pickup or delivery to check store availability';
      stockImg?.classList.add('hidden');
      stockOutImg?.classList.add('hidden');
      stockLabel.classList.remove('in-stock');
    }

    const buyBtns = productInfo.querySelectorAll('.product-info__add-button button');
    buyBtns.forEach((btn) => {
      btn.disabled = false;
      btn.setAttribute('aria-disabled', 'false');

      if (btn.getAttribute('data-type') !== 'promo' && btn.textContent.trim() === 'SOLD OUT') {
        btn.textContent = 'ADD TO CART';
      }
    });
  }

  openPopup() {
    this.classList.remove('hide');
  }

  checkLocalStorage() {
    let preferred = null;

    try {
      const storedPreferred = localStorage.getItem('preferredLocation');
      const parsedPreferred = storedPreferred ? JSON.parse(storedPreferred) : null;

      if (parsedPreferred && typeof parsedPreferred === 'object' && parsedPreferred.id) {
        preferred = parsedPreferred;
      }
    } catch (error) {
      preferred = null;
    }

    if (preferred) {
      this.deliveyOptions.forEach(option => {
        const input = option.querySelector('input');
        input.checked = false;
        if(preferred.method === input.value){
          input.checked = true;
          this.deliveryMethod.setAttribute('data-selected-value', input.value);
        }
      });
      // set active list for location and method
      const methods = ['Local Delivery', 'In-Store Pickup']
      if(!methods.includes(preferred.method)){
        return;
      }
      if(preferred.method === 'Local Delivery'){
        this.valid_zip = true;
        this.querySelector('#zipcode').value = preferred?.zip;
        const locations = this.getLocations(preferred?.zip);
        this.deliveryLocation.populateOptions(locations);
        this.setActiveList(this.deliveryLocation,preferred.location, preferred.id);
        this.deliveryLocation.querySelector('button').disabled = true;
        this.deliveryClasses();
      } else {
        const locations = this.getLocations();
        this.pickupLocation.populateOptions(locations);
        this.setActiveList(this.pickupLocation,preferred.location, preferred.id);
        this.pickupClasses();
      }
      this.filterProductsByTag(preferred.id);
    } else {
      if(!this.alreadyClicked) {
        for(const option of Array.from(this.deliveyOptions)){
          const input = option.querySelector('input');
          input.checked = true;
          this.deliveryMethod.setAttribute('data-selected-value', input.value);
          break;
        };
      }
      this.classList.remove('hide');
    }
  }

  pickupClasses(){
    this.querySelector('.zip__container').classList.add('hidden');
    this.querySelector('.pickup-results').classList.remove('hidden');
    this.querySelector('.local__delivery-results').classList.add('hidden');
  }

  deliveryClasses(){
    this.querySelector('.zip__container').classList.remove('hidden');
    this.querySelector('.local__delivery-results').classList.remove('hidden');
    this.querySelector('.pickup-results').classList.add('hidden');
  }

  handleWarning(evt){
    const zip = this.querySelector('#zipcode')?.value;
    const selectedMethod = this.deliveryMethod?.getAttribute('data-selected-value')?.trim();
    // console.log('this.valid', this.valid_zip);
    if(!zip && selectedMethod==='Local Delivery'){
      // console.log('in not having zip code block')
      this.setErrorMessage("Enter a valid 5-digit ZIP code.");
      return;
    } else if(selectedMethod==='Local Delivery' && !this.valid_zip){
      // console.log('in not valid zip code block')
      return;
    }
    const cartItems = document.querySelector('cart-items[data-empty="false"]');
    // console.log(cartItems);
    if (!cartItems) {
      this.handleConfirm(evt);
    } else {
      const popupInfo = this.querySelector('.popup__info');
      const confirmInfo = this.querySelector('.confirm__info');
      popupInfo.classList.add('hidden');
      confirmInfo.classList.remove('hidden');
    }
  }

  handleBack(){
    const popupInfo = this.querySelector('.popup__info');
    const confirmInfo = this.querySelector('.confirm__info');
    popupInfo.classList.remove('hidden');
    confirmInfo.classList.add('hidden');
    this.classList.add('hide');
  }

  handleInput() {
    if (this.input.value.length === 5) {
      const minZipCodeTX = 73301;
      const maxZipCodeTX = 88595;
      const value = parseInt(this.input.value, 10);
      this.removeActiveButton(this.deliveryLocation.querySelector('button'));
      this.deliveryLocation.querySelector('.custom-select__listbox').innerHTML = '';
      if(value < minZipCodeTX || value > maxZipCodeTX){
        this.valid_zip = false;
        this.querySelector('.local__delivery-results').classList.add('hidden');
        this.setErrorMessage("Local delivery isn't available for this ZIP code. You can still choose In-Store Pickup from any Paws on Chicon location.");
      } else {
        // console.log('within of range', value);
        const zipCodes = sessionStorage.getItem('zip_codes') || null;
        if(!zipCodes) return;
        // console.log('zip codes', zipCodes);
        const hasZipCode = zipCodes.includes(this.input.value);
        if(!hasZipCode) {
          this.valid_zip = false;
          this.querySelector('.local__delivery-results').classList.add('hidden');
          this.setErrorMessage("Local delivery isn't available for this ZIP code. You can still choose In-Store Pickup from any Paws on Chicon location.");
        } else {
          this.setErrorMessage();
          const locations = this.getLocations(this.input.value);
          this.deliveryLocation.populateOptions(locations);
          this.valid_zip = true;
          this.deliveryLocation.querySelector('button').disabled = true;
          this.querySelector('.local__delivery-results').classList.remove('hidden');
        }
      }
    } else {
      this.valid_zip = false;
      this.setErrorMessage("Enter a valid 5-digit ZIP code.");
      this.querySelector('.local__delivery-results').classList.add('hidden');
      this.removeActiveButton(this.deliveryLocation.querySelector('button'));
      this.deliveryLocation.querySelector('.custom-select__listbox').innerHTML = '';
    }
  }

  getLocations (zip = null) {
    const data = JSON.parse(sessionStorage.getItem('locations')) || null;
    if (!data || !data?.processedLocations) {
      return [];
    }
    // console.log('get locations zip', zip);
    if(zip){
      return data.processedLocations.filter(loc => loc?.zipCodes?.includes(zip));
    } else {
      return data.processedLocations;
    }
  }

  setErrorMessage(errorMessage, hidden = false) {
    if(!errorMessage){
      hidden = true;
      errorMessage = '';
    }
    this.errorMessage.hidden = hidden ? true : false;
    this.errorMessage.textContent = errorMessage;
    this.errorMessage.setAttribute("aria-hidden", hidden ? "true" : "false");
  }

  removeActiveButton(element, text = null){
    element.removeAttribute('data-value');
    element.removeAttribute('data-id');
    element.firstElementChild.textContent = text != null ? text : '';
  }

  handleDeliveryOptionClick(option){
    this.deliveyOptions.forEach(option => option.querySelector('input').checked = false);
    const input = option.querySelector('input');
    input.checked = true;
    this.deliveryMethod.setAttribute('data-selected-value', input.value);
    if(input.name ==='pickup'){
      this.valid_zip = false;
      this.pickupClasses();
      this.removeActiveButton(this.pickupLocation.querySelector('button'), "Select Store");
    } else {
      this.input.value = '';
      this.deliveryClasses();
      this.removeActiveButton(this.deliveryLocation.querySelector('button'));
      this.deliveryLocation.querySelector('.custom-select__listbox').innerHTML = '';
      this.querySelector('.local__delivery-results').classList.add('hidden');
    }
    this.setErrorMessage();
    this.alreadyClicked = true;
  }

  fetchStateData() {
    const cachedData = sessionStorage.getItem('zip_codes') || null;
    if(!cachedData) {
      return fetch('/apps/stock_info/location', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            'Network response was not ok ' + response.statusText
          );
        }
        return response.json();
      })
      .then((data) => {
        // this.setStorage('locations', JSON.stringify(data), 3600);
        const locationsLen = data?.processedLocations?.length;
        let zipcodes = data?.processedLocations?.reduce((acc, curr, i)=> {
          acc+=curr.zipCodes != null ? (curr.zipCodes + (i < locationsLen - 1 ? ', ': '')): '' ;
          return acc;
        }, '');
        sessionStorage.setItem('zip_codes', JSON.stringify(zipcodes));
        sessionStorage.setItem('locations', JSON.stringify(data));
        this.pickupLocation.populateOptions(data.processedLocations);
      })
      .catch((error) => console.error('Error:', error));
    }
  }

  setActiveList(element, value, dataId = null){
    const button = element.querySelector('button');
    const list = element.querySelector('ul');
    const options = element.querySelectorAll('li');
    button.setAttribute('data-value', value);
    button.firstElementChild.textContent = value;
    if(dataId) button.setAttribute('data-id', dataId);
    options.forEach(option => {
      if(option.firstElementChild.textContent === value){
        option.setAttribute('aria-selected', 'true');
        option.classList.add('is-focused');
        list.setAttribute('aria-activedescendant', option.id);
      } else {
        option.setAttribute('aria-selected', 'false');
        option.classList.remove('is-focused');
      }
    });
  }

  async refreshCurrentVariantStock() {
    if (this.template !== 'product') return;

    const productInfo = document.querySelector('.product-info');
    const variantId = productInfo?.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    try {
      const response = await fetch('/apps/stock_info/inventory_levels', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: variantId })
      });

      if (!response.ok) {
        throw new Error(`Inventory request failed: ${response.status}`);
      }

      const stockData = await response.json();
      window.stock = stockData;

      const stockInline = document.querySelector('stock-inline');
      const policy = productInfo.getAttribute('data-inventory-policy');

      if (stockInline) {
        this.updateCountDisplay();
      }

      if (policy !== 'continue') {
        this.toggleButtonDisable();
      }
    } catch (error) {
      console.error('Error refreshing stock after location change:', error);

      const policy = productInfo?.getAttribute('data-inventory-policy');
      if (policy !== 'continue') {
        this.diableButton(true);
      }
    }
  }

  async handleConfirm(evt) {
    const selectedMethod = this.deliveryMethod?.getAttribute('data-selected-value')?.trim();
    let zip = null;
    let selectedLocation = null;
    let id = null;
    if(selectedMethod ==='Local Delivery'){
      selectedLocation = this.deliveryLocation.querySelector('.custom-select__btn')?.getAttribute('data-value')?.trim();
      id = this.deliveryLocation.querySelector('.custom-select__btn').getAttribute('data-id')?.trim();
      zip = this.querySelector('#zipcode')?.value;
    } else {
      selectedLocation = this.pickupLocation.querySelector('.custom-select__btn')?.getAttribute('data-value')?.trim();
      id = this.pickupLocation.querySelector('.custom-select__btn')?.getAttribute('data-id')?.trim();
    }
    const stockInline = document.querySelector('stock-inline');
    let prevPreferred = null;

    try {
      const storedPreferred = localStorage.getItem('preferredLocation');
      const parsedPreferred = storedPreferred ? JSON.parse(storedPreferred) : null;

      if (parsedPreferred && typeof parsedPreferred === 'object' && parsedPreferred.id) {
        prevPreferred = parsedPreferred;
      }
    } catch (error) {
      prevPreferred = null;
    }

    if (selectedLocation && selectedMethod) {
      // Update preferred location and method in local storage
      if(prevPreferred && prevPreferred.id === id && prevPreferred.method === selectedMethod) {
        this.classList.add('hide');
        this.handleBack();
        return;
      }
      const preferred = { id: id, location: selectedLocation, method: selectedMethod };
      if(zip) preferred.zip = zip;
      localStorage.setItem('preferredLocation', JSON.stringify(preferred));

      this.filterProductsByTag(id);

      // Hide popup and error message
      this.classList.add('hide');
      this.setErrorMessage();

      await this.handleEmptyCart(id, selectedLocation, selectedMethod, zip, evt);
      await this.refreshCurrentVariantStock();

      this.updateHeaderDisplay(selectedLocation, selectedMethod);
      this.updateHeaderDisplay(selectedLocation, selectedMethod, true);
      this.handleBack();
    } else {
      this.setErrorMessage('Choose In-Store Pickup or Local Delivery, then select a location.');
    }
  }

  handleClose(evt) {
    this.classList.add('hide');
    this.setErrorMessage();
    this.handleBack();
  }
  
  filterProductsByTag(location) {
    const products = document.querySelectorAll('.product-card');
    if(products && products.length > 0) {
      products.forEach((product) => {
        const policy = product.getAttribute('data-inventory-policy') === 'continue';
        if(!policy){
          const locationTags = product?.getAttribute('data-locations')?.split(',');
          const unavailableLabel = product.querySelector('.product-label-location-out');
          const button = product.querySelector('button');
          if (!locationTags?.includes(location)) {
            product.classList.add('location-sold-out');
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
            if(unavailableLabel) unavailableLabel.classList.remove('hidden');
          } else {
            product.classList.remove('location-sold-out');
            button.disabled = false;
            button.setAttribute('aria-disabled', 'false');
            if(unavailableLabel) unavailableLabel.classList.add('hidden');
          }
        }
      });
    }
  }
  // update header for location
  updateHeaderDisplay(selectedState = 'Shopping location', selectedDM = 'Choose pickup or delivery', mobile=false) {
    const currentLElem = document.getElementById(`${mobile ? 'mbl-' : ''}current-state`);
    const currentDMElem = document.getElementById(`${mobile ? 'mbl-' : ''}current-delivery-method`);

    if (currentLElem) currentLElem.textContent = `${selectedState}`;
    if (currentDMElem) currentDMElem.textContent = `${selectedDM}`;
  }

  // update stock availability for location changed
  updateCountDisplay() {
    let preferred = null;

    try {
      const storedPreferred = localStorage.getItem('preferredLocation');
      const parsedPreferred = storedPreferred ? JSON.parse(storedPreferred) : null;

      if (parsedPreferred && typeof parsedPreferred === 'object' && parsedPreferred.id) {
        preferred = parsedPreferred;
      }
    } catch (error) {
      preferred = null;
    }

    const counts = document.querySelectorAll('.stock__count--inline');
    const p = document.querySelector(".stock__availability");

    if (!preferred) {
      counts.forEach((count) => count.classList.add('hidden'));
      if (p) {
        let neutral = p.querySelector('.stock__count--inline.stock__location-required');
        if (!neutral) {
          p.insertAdjacentHTML(
            'beforeend',
            '<span class="stock__count--inline stock__location-required">Choose pickup or delivery to check store availability</span>'
          );
        } else {
          neutral.classList.remove('hidden');
        }
      }
      return;
    }

    const neutral = p?.querySelector('.stock__count--inline.stock__location-required');
    if (neutral) neutral.classList.add('hidden');

    const unavailable = document.querySelector(`.stock__count--inline.location\\:${preferred.id}`);
    counts.forEach((count) => {
      if(count.classList.contains(`location:${preferred.id}`)) {
        count.classList.remove('hidden');
      } else {
        count.classList.add('hidden');
      }
    })
    if(!unavailable && p){
      p.insertAdjacentHTML('beforeend', `<span class="stock__count--inline location:${preferred.id} stock__out">Unavailable</span>`)
    }
  }

  toggleButtonDisable(){
    const quantityInput = document.querySelector('.product-info .qty-input__input');
    const plusButton = document.querySelector('.product-info .qty-input__btn[name="plus"]');
    if (quantityInput) quantityInput.value = 1;
    if (plusButton) plusButton.disabled = false;

    const stockOutImg = document.querySelector('.stock__label .out-stock');
    const stockImg = document.querySelector('.stock__label .in-stock');
    const hasStockLabelImgs = stockOutImg && stockImg;

    let preferred = null;

    try {
      const storedPreferred = localStorage.getItem('preferredLocation');
      const parsedPreferred = storedPreferred ? JSON.parse(storedPreferred) : null;

      if (parsedPreferred && typeof parsedPreferred === 'object' && parsedPreferred.id) {
        preferred = parsedPreferred;
      }
    } catch (error) {
      preferred = null;
    }

    if (!preferred) {
      const stockLabel = document.querySelector('.stock__label');
      if (stockLabel) {
        stockLabel.lastElementChild.textContent = 'Choose pickup or delivery to check store availability';
        stockImg?.classList.add('hidden');
        stockOutImg?.classList.add('hidden');
        stockLabel.classList.remove('in-stock');
      }
      return;
    }

    // console.log(window.stock);
    const stockFound = window?.stock?.find(item => {
      if (!item?.locationId) return false;
      const id = item.locationId.split('/').pop();
      return id === preferred.id;
    });
    if(stockFound) {
      const stockCount = stockFound.stock;
      // console.log(stockCount);
      if(stockCount >= 1){
        this.diableButton(false, 'ADD TO CART');
        if (hasStockLabelImgs) this.showLabel(stockImg, stockOutImg, true);
      } else {
        this.diableButton(true, 'SOLD OUT');
        if (hasStockLabelImgs) this.showLabel(stockImg, stockOutImg, false);
      }
    } else {
      this.diableButton(true, 'SOLD OUT');
      if (hasStockLabelImgs) this.showLabel(stockImg, stockOutImg, false);
    }
  }

  showLabel(stockImg, stockOutImg, stock = false){
    const stockLabel = document.querySelector('.stock__label');
    if (!stockLabel) return;
    stockLabel.lastElementChild.textContent = stock ? "In stock": "Out of stock";
    if(stock){
      stockImg?.classList.remove('hidden');
      stockOutImg?.classList.add('hidden');
      stockLabel.classList.add('in-stock');
    } else {
      stockImg?.classList.add('hidden');
      stockOutImg?.classList.remove('hidden');
      stockLabel.classList.remove('in-stock');
    }
  }

  diableButton(disabled = true, text = null) {
    const dynamicBtn = document.querySelector(
      '.product-info__dynamic-checkout-btn shopify-accelerated-checkout'
    );
    const buyBtns = document.querySelectorAll('.product-info__add-button button');
    buyBtns.forEach(btn => {
      btn.disabled = disabled ? true : false;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      const promoBtn = btn.getAttribute('data-type') === 'promo';
      const btnText = btn.textContent;
      if(text) btn.textContent = promoBtn ? btnText : text;
    })
    if (dynamicBtn) dynamicBtn.disabled = disabled ? true : false;
  }

  // empty cart on location change and update cart attributes 
  async handleEmptyCart(id, location, method, zip = null, evt) {
    evt.preventDefault();

    try {
      const clearResponse = await fetch(`${theme.routes.cartClear}.js`, {
        method: 'POST'
      });

      if (!clearResponse.ok) throw new Error(clearResponse.status);

      // Broadcast individual events to update product cards
      const cartItems = document.querySelector('cart-items[data-empty="false"]');
      if(cartItems){
        cartItems.querySelectorAll('.cart-item').forEach((cartItem) => {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              variantId: cartItem.dataset.variantId,
              newQuantity: 0
            }
          }));
        });
        this.refreshCartDrawer(cartItems);
      }

      // Proceed to update cart attributes
      const updateResponse = await fetch(theme.routes.cartUpdate, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            store_id: id,
            store: location,
            shipping_type: method,
            zip: zip ? zip : 'nil'
          }
        }),
      });

      if (!updateResponse.ok) throw new Error(updateResponse.status);
    } catch (error) {
      console.error('cart update Error at location selection:', error);
      throw error;
    }
  }

  // refresh cart drawer if it has items
  refreshCartDrawer(items) {
    try {
      items.refreshCartItems();
    } catch (error) {
      this.dispatchEvent(new CustomEvent('on:cart:error', {
        bubbles: true,
        detail: {
          error: error ? error.message : null
        }
      }));
    }
  }
}

if (!customElements.get('state-popup')) {
  customElements.define('state-popup', StatePopup);
}